import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const FlowApi = createApi({
  reducerPath: "FlowApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["FLOWS"],
  endpoints: (build) => ({
    getFlows: build.query({
      query: ({ botId, page = 1, limit = 20 }) =>
        `/${botId}/flows?page=${page}&limit=${limit}`,
      providesTags: ["FLOWS"],
    }),

    getFlowByVersion: build.query({
      query: ({ botId, version }) => `/${botId}/flows/${version}`,
      providesTags: ["FLOWS"],
    }),

    createFlow: build.mutation({
      query: ({ botId, data }) => ({
        url: `/${botId}/flows`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["FLOWS"],
    }),

    publishFlow: build.mutation({
      query: ({ botId, version }) => ({
        url: `/${botId}/flows/${version}/publish`,
        method: "POST",
      }),
      invalidatesTags: ["FLOWS"],
    }),

    rollbackFlow: build.mutation({
      query: ({ botId, version }) => ({
        url: `/${botId}/flows/${version}/rollback`,
        method: "POST",
      }),
      invalidatesTags: ["FLOWS"],
    }),
  }),
});

export const {
  useGetFlowsQuery,
  useGetFlowByVersionQuery,
  useCreateFlowMutation,
  usePublishFlowMutation,
  useRollbackFlowMutation,
} = FlowApi;
